import { ReserveCodeComboBoxComponent } from '../reserve-code-combo-box/reserve-code-combo-box.component';
import { PlessViewUtilsSub } from '../../../kymw00/pless-view-utils-sub.service';

/**
 * コードコンボボックスモデル
 *
 * @export ReserveCodeComboBoxModel
 * @class ReserveCodeComboBoxModel
 */
export class ReserveCodeComboBoxModel {

  /**
   * コードリスト
   */
  public codeList: any[] = [];
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // 最新情報表示
  public latestInfo: boolean = <boolean>false;
  // コンボボックスインスタンス
  public component: ReserveCodeComboBoxComponent;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 初期設定コード値
  public setCodeValue: string = <string>'';
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  // 初期設定インデックス
  public setSelectedIndex: number = <number>-1;
  // コード区分初期化済フラグ
  public isInitCodeDiv: boolean = <boolean>false;


  /**
   * コードリストを更新する
   *
   * @param {*} serverData コードリストのサーバ取得データ
   * @returns {void}
   * @memberof CodeComboBoxModel
   */
  public updateCodeList(serverData: any[]): void {
    let tempDataList: any[] = [];

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = [];
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    if (this.blank) {
      tempDataList.splice(index, 0, this.getBlankObject('', ''));
      index += 1;
    }

    // 最新情報表示
    if (this.latestInfo) {
      tempDataList.splice(index, 0, this.getBlankObject('*', '最新情報'));
      index += 1;
    }

    // コード + ： + 名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].codeValueName = tempDataList[index].CodeValue + ':' + tempDataList[index].CodeName;
    }

    this.codeList = tempDataList;
    this.completeUpdateFlg = true;

    // 選択コードが設定されたら優先する
    if (PlessViewUtilsSub.isEmpty(String(this.setCodeValue)) &&
      (0 < this.codeList.length)) {
      this.setCodeValue = <string>this.codeList[0].CodeValue;
    }

    this.component.updateSelectedCodeValue();
  }

  /**
   * 空白のオブジェクトを取得する
   *
   * @private
   * @param {string} codeValue
   * @param {string} codeName
   * @returns {*} オブジェクト
   * @memberof CodeComboBoxModel
   */
  private getBlankObject(codeValue: string, codeName: string): any {
    return {
      CodeDiv: '',
      CodeValue: codeValue,
      CodeName: codeName,
      CodeDivName: '',
      codeValueName: !PlessViewUtilsSub.isEmpty(String(codeValue)) && !PlessViewUtilsSub.isEmpty(String(codeName)) ?
        codeValue + ':' + codeName : codeValue + codeName,
      Reserve1: '',
      Reserve2: '',
      ReserveNum1: '',
      ReserveNum2: '',
      SortNum: '',
      StartOrderCode: '',
      EndOrderCode: ''
    };
  }

}
